import { TextArea } from 'components/Inputs/';
import { capitalizeFirstLetter } from 'utils/';
import React, { useState, useEffect } from 'react';
import { FlexCol, FlexRow } from 'components/Layout/';
import { ReactComponent as ArrowIcon } from 'icons/tick.svg';
import { CancelButton, RoundButton } from 'components/Buttons/';

export function Order({ onClose, onSubmit, initialValue = {} }) {
  const { id, default_notes: defaultNotes = {} } = initialValue;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { order_notes: orderNotes = '', asset_notes: assetNotes = '' } =
    defaultNotes;
  const [state, setState] = useState({ orderNotes, assetNotes });
  const [errors, setErrors] = useState({ orderNotes: '', assetNotes: '' });

  function onInputChange(event) {
    const { currentTarget } = event;
    const { name, value } = currentTarget;
    setState({ ...state, [name]: value });
  }

  function onSubmitSettings() {
    const valid = validateForm();
    if (valid) {
      setIsSubmitting(true);
      const { orderNotes, assetNotes } = state;
      const data = {
        features_enabled: {
          tasks: true,
          assets: true,
          inventory: true,
        },
        default_notes: {
          order_notes: orderNotes,
          asset_notes: assetNotes,
        },
      };
      onSubmit(data, id);
    }
  }

  function validateForm() {
    let isFormValid = true;
    let errorObject = { ...errors };
    for (const [key, value] of Object.entries(state)) {
      if (!value) {
        isFormValid = false;
        errorObject = {
          ...errorObject,
          [key]: `${capitalizeFirstLetter(key, true)} is required`,
        };
      } else {
        errorObject = { ...errorObject, [key]: '' };
      }
    }
    setErrors(errorObject);
    return isFormValid;
  }

  useEffect(() => {
    if (isSubmitting) {
      validateForm();
    }
  }, [state, isSubmitting]);

  return (
    <>
      <FlexRow>
        <FlexCol flexWidth={12}>
          <TextArea
            isRequired
            height={50}
            inputType="text"
            name="orderNotes"
            inputId="orderNotes"
            value={state.orderNotes}
            onChange={onInputChange}
            errorMessage={errors.orderNotes}
            caption="Default Order Terms & Conditions"
            placeholder="Enter Default Order Terms & Conditions"
          />
        </FlexCol>
      </FlexRow>
      <FlexRow>
        <FlexCol flexWidth={12}>
          <TextArea
            isRequired
            height={50}
            inputType="text"
            name="assetNotes"
            inputId="assetNotes"
            value={state.assetNotes}
            onChange={onInputChange}
            errorMessage={errors.assetNotes}
            caption="Default Asset Terms & Conditions"
            placeholder="Enter Default Asset Terms & Conditions"
          />
        </FlexCol>
      </FlexRow>
      <FlexRow className="modal-buttons-row">
        <RoundButton
          caption="Save"
          icon={<ArrowIcon />}
          className="modal-button"
          onClick={onSubmitSettings}
        />
        <CancelButton onClick={onClose} />
      </FlexRow>
    </>
  );
}
